/**
 * Query keys for organization-related queries
 * Following controller method naming convention
 */
export const organizationKeys = {
  getCurrentOrganization: () =>
    ["organization", "getCurrentOrganization"] as const,
  getProfile: (uuid: string) => ["organization", "getProfile", uuid] as const,
  // Profile operations
  updateProfile: () => ["organization", "updateProfile"] as const,
  publishProfile: () => ["organization", "publishProfile"] as const,
  unpublishProfile: () => ["organization", "unpublishProfile"] as const,
  generatePreviewToken: () => ["organization", "generatePreviewToken"] as const,
  // Logo operations
  uploadLogo: () => ["organization", "uploadLogo"] as const,
  deleteLogo: () => ["organization", "deleteLogo"] as const,
  // Ownership operations
  getEligibleOwners: () => ["organization", "getEligibleOwners"] as const,
  getApprovalRequestSummary: (uuid: string) =>
    ["organization", "getApprovalRequestSummary", uuid] as const,
  getOwnership: () => ["organization", "getOwnership"] as const,
  getPendingOwnershipTransfer: () =>
    ["organization", "getPendingOwnershipTransfer"] as const,
  getPendingOrganizationDeletion: () =>
    ["organization", "getPendingOrganizationDeletion"] as const,
  initiateOwnershipTransfer: () =>
    ["organization", "initiateOwnershipTransfer"] as const,
  confirmOwnershipTransfer: () =>
    ["organization", "confirmOwnershipTransfer"] as const,
  cancelOwnershipTransfer: () =>
    ["organization", "cancelOwnershipTransfer"] as const,
  // Deletion operations
  initiateOrganizationDeletion: () =>
    ["organization", "initiateOrganizationDeletion"] as const,
  confirmOrganizationDeletion: () =>
    ["organization", "confirmOrganizationDeletion"] as const,
  cancelOrganizationDeletionRequest: () =>
    ["organization", "cancelOrganizationDeletionRequest"] as const,
  cancelScheduledOrganizationDeletion: () =>
    ["organization", "cancelScheduledOrganizationDeletion"] as const,
} as const
